<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { date } from 'quasar';
import {
  mdiHistory,
  mdiBookOpenPageVariantOutline,
  mdiViewGridOutline,
  mdiCheckboxMarkedCircleOutline,
} from '@quasar/extras/mdi-v7';

defineProps<{
  recentActivity: {
    type: string;
    id: number;
    name: string;
    date: string;
    score: number;
  }[];
}>();

const { t } = useI18n();

function formatDate(value: string) {
  return value ? date.formatDate(value, 'DD/MM/YYYY HH:mm') : '';
}

function activityTypeLabel(type: string) {
  const normalized = `${type || ''}`.toLowerCase();
  if (normalized === 'step') return t('STEP');
  if (normalized === 'section') return t('SECTION');
  if (normalized === 'course') return t('COURSE');
  return type;
}

function typeMeta(type: string) {
  const normalized = `${type || ''}`.toLowerCase();
  if (normalized === 'course')
    return { icon: mdiBookOpenPageVariantOutline, acc: 'acc-courses' };
  if (normalized === 'section')
    return { icon: mdiViewGridOutline, acc: 'acc-sections' };
  return { icon: mdiCheckboxMarkedCircleOutline, acc: 'acc-steps' };
}

function scoreColor(score: number) {
  if (score >= 80) return 'positive';
  if (score >= 50) return 'warning';
  return 'negative';
}
</script>
<template>
  <div class="stat-card acc-neutral">
    <div class="stat-card__head">
      <div class="stat-card__title">{{ $t('RECENT_ACTIVITY') }}</div>
      <div class="stat-badge stat-badge--sm">
        <q-icon
          :name="mdiHistory"
          size="18px"
        />
      </div>
    </div>

    <div
      v-if="recentActivity.length"
      class="stat-rows"
    >
      <div
        v-for="item in recentActivity"
        :key="item.type + '-' + item.id"
        class="stat-row"
        :class="typeMeta(item.type).acc"
      >
        <div class="stat-badge stat-badge--sm">
          <q-icon
            :name="typeMeta(item.type).icon"
            size="18px"
          />
        </div>
        <div class="stat-row__text">
          <div class="stat-label ellipsis">{{ item.name }}</div>
          <div class="stat-sub">
            {{ activityTypeLabel(item.type) }} · {{ formatDate(item.date) }}
          </div>
        </div>
        <q-chip
          dense
          :color="scoreColor(item.score)"
          text-color="white"
          class="text-weight-bold"
        >
          {{ item.score }}
        </q-chip>
      </div>
    </div>

    <div
      v-else
      class="stat-empty"
    >
      {{ $t('NO_DATA_AVAILIABLE') }}
    </div>
  </div>
</template>
